import React, { useState, useEffect } from 'react';
import CommonNav from './CommonNav'
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import SubDropdown from './SubDropdown';
//import MultiSelectSub from './MultiSelectSub';
import SubstituteGroupsViewer from './SubstituteGroupsViewer';
import { Card } from 'primereact/card';
import subSchedule from '../mock/subschedulelist.json';
import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


function ScheduleSub() {
    const [date, setDate] = useState('');
    const [dates, setDates] = useState([]);
    const [selectedSub, setSelectedSub] = useState(null);
    const [disabledDates, setDisabledDates] = useState([]);
    const [filteredById, setFilteredById] = useState([]);
    const [message, setMessage] = useState('');
    const [subPhoneNumbers, setSubPhoneNumbers] = useState([]);
    const [selectedSubs, setSelectedSubs] = useState([]);

    const handleChildData = (data) => {

        const subPhoneNumbersMapped = data.map((teacher) => (teacher.phone));
        console.log(subPhoneNumbersMapped);
        setSubPhoneNumbers(subPhoneNumbersMapped);
        setSelectedSubs(data);
        console.log("Setting data");
        console.log(subPhoneNumbersMapped);
    };

    const handleSubChange = (sub) => {
        setSelectedSub(sub);
        const filteredBySub = subSchedule.filter(item => item.id === sub?.id.toString());
        setFilteredById(filteredBySub);
    };

    const handleGetPhoneNumbers = () => {
        console.log("Getting phone numbers");
        console.log(subPhoneNumbers);
    };

    const handleCalendarChange = (d) => {
        console.log("Getting dates");
        console.log(date);
    };

    useEffect(() => {
        console.log("attempting to map filteredById");
        const parsedDates = filteredById.map(item => new Date(item.scheduled));
        setDisabledDates(parsedDates);

    }, [selectedSub]);


    const dateTemplate = (dateMeta) => {
        const isDisabled = disabledDates.some(
            d =>
                d.getFullYear() === dateMeta.year &&
                d.getMonth() === dateMeta.month &&
                d.getDate() === dateMeta.day
        );

        return (
            <span style={ isDisabled ? { color: "red" } : {} }>
                {dateMeta.day}
            </span>
            );
    };



    return (
    <>
        <CommonNav></CommonNav>
        <br />
        <br />
        <br />

        <div className="card flex flex-column align-items-center gap-5 ">
            <Card title="Schedule Substitute">
                <div className="card flex flex-column align-items-center gap-5 ">
                    <SubDropdown  onSubChange={handleSubChange}></SubDropdown>
                    <Calendar className="p-calendar" value={date} onChange={(e) => setDates(e.value)} numberOfMonths={1}
                    inline showWeek dateTemplate={dateTemplate} disabledDates={disabledDates} selectionMode="range" />
                    <div className="card">
                        <div className="card-body">
                            <div>
                                {filteredById.length > 0 ? (
                                    <p>{filteredById.length} day(s) scheduled</p>
                                    ) : (
                                    <p></p>
                                )}
                            </div>


                            <ListBox disabled options={dates} optionLabel="scheduled" className="w-full md:w-14rem" />
                            <ListBox disabled options={filteredById} optionLabel="scheduled" className="w-full md:w-14rem" />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />

                            <SubstituteGroupsViewer subPhoneNumbers={subPhoneNumbers} onGetPhoneNumbers={handleChildData} />
                            <br />
                            <Button label="Get Phone Numbers" severity="success" onClick={handleGetPhoneNumbers} />
                            <br />
                            <div className="card">
                                <DataTable value={selectedSubs} tableStyle={{ minWidth: '50rem' }}>
                                    <Column field="fullName" header="Name"></Column>
                                    <Column field="phone" header="Phone"></Column>
                                </DataTable>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />

                        </div>
                    </div>
                </div>
            </Card>
        </div>
    </>
    );
}

export default ScheduleSub;